// ═══════════════════════════════════════
// SIMPLE THINGS — st-custom.js
// ═══════════════════════════════════════

// ── Custom Cursor ───────────────────
document.addEventListener('DOMContentLoaded', function () {
  const cur = document.createElement('div');
  cur.id = 'st-cursor';
  document.body.appendChild(cur);

  document.addEventListener('mousemove', e => {
    cur.style.left = e.clientX + 'px';
    cur.style.top  = e.clientY + 'px';
  });

  document.addEventListener('mouseover', e => {
    if (e.target.closest('a, button, [role="button"], label, select, input')) {
      cur.classList.add('hovering');
    }
  });

  document.addEventListener('mouseout', e => {
    if (e.target.closest('a, button, [role="button"], label, select, input')) {
      cur.classList.remove('hovering');
    }
  });

  document.addEventListener('mouseleave', () => cur.style.opacity = '0');
  document.addEventListener('mouseenter', () => cur.style.opacity = '1');
});